/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Domain,
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
} from './Domain';
import {
    FundamentalDomain,
    FundamentalDomainFromJSON,
    FundamentalDomainFromJSONTyped,
    FundamentalDomainToJSON,
} from './FundamentalDomain';
import {
    IndicatorTypeEnum,
    IndicatorTypeEnumFromJSON,
    IndicatorTypeEnumFromJSONTyped,
    IndicatorTypeEnumToJSON,
} from './IndicatorTypeEnum';
import {
    IndicatorValueTypeEnum,
    IndicatorValueTypeEnumFromJSON,
    IndicatorValueTypeEnumFromJSONTyped,
    IndicatorValueTypeEnumToJSON,
} from './IndicatorValueTypeEnum';
import {
    ScienceBranch,
    ScienceBranchFromJSON,
    ScienceBranchFromJSONTyped,
    ScienceBranchToJSON,
} from './ScienceBranch';

/**
 * 
 * @export
 * @interface Indicator
 */
export interface Indicator {
    /**
     * 
     * @type {string}
     * @memberof Indicator
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Indicator
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Indicator
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Indicator
     */
    fundamentalDomainId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Indicator
     */
    scienceBranchId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Indicator
     */
    domainId?: string | null;
    /**
     * 
     * @type {IndicatorTypeEnum}
     * @memberof Indicator
     */
    indicatorType?: IndicatorTypeEnum;
    /**
     * 
     * @type {IndicatorValueTypeEnum}
     * @memberof Indicator
     */
    indicatorValueType?: IndicatorValueTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Indicator
     */
    indicatorValue?: number;
    /**
     * 
     * @type {FundamentalDomain}
     * @memberof Indicator
     */
    fundamentalDomain?: FundamentalDomain;
    /**
     * 
     * @type {ScienceBranch}
     * @memberof Indicator
     */
    scienceBranch?: ScienceBranch;
    /**
     * 
     * @type {Domain}
     * @memberof Indicator
     */
    domain?: Domain;
}

export function IndicatorFromJSON(json: any): Indicator {
    return IndicatorFromJSONTyped(json, false);
}

export function IndicatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Indicator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'fundamentalDomainId': !exists(json, 'fundamentalDomainId') ? undefined : json['fundamentalDomainId'],
        'scienceBranchId': !exists(json, 'scienceBranchId') ? undefined : json['scienceBranchId'],
        'domainId': !exists(json, 'domainId') ? undefined : json['domainId'],
        'indicatorType': !exists(json, 'indicatorType') ? undefined : IndicatorTypeEnumFromJSON(json['indicatorType']),
        'indicatorValueType': !exists(json, 'indicatorValueType') ? undefined : IndicatorValueTypeEnumFromJSON(json['indicatorValueType']),
        'indicatorValue': !exists(json, 'indicatorValue') ? undefined : json['indicatorValue'],
        'fundamentalDomain': !exists(json, 'fundamentalDomain') ? undefined : FundamentalDomainFromJSON(json['fundamentalDomain']),
        'scienceBranch': !exists(json, 'scienceBranch') ? undefined : ScienceBranchFromJSON(json['scienceBranch']),
        'domain': !exists(json, 'domain') ? undefined : DomainFromJSON(json['domain']),
    };
}

export function IndicatorToJSON(value?: Indicator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'fundamentalDomainId': value.fundamentalDomainId,
        'scienceBranchId': value.scienceBranchId,
        'domainId': value.domainId,
        'indicatorType': IndicatorTypeEnumToJSON(value.indicatorType),
        'indicatorValueType': IndicatorValueTypeEnumToJSON(value.indicatorValueType),
        'indicatorValue': value.indicatorValue,
        'fundamentalDomain': FundamentalDomainToJSON(value.fundamentalDomain),
        'scienceBranch': ScienceBranchToJSON(value.scienceBranch),
        'domain': DomainToJSON(value.domain),
    };
}

